import request from "@utils/request";

export function getDataTimeDecay(query) {
    return request({
        url: 'alert/data/time-decay',
        method: 'get',
        params: query
    })
}
